import React from 'react';

//import Scss
import './assets/scss/themes.scss';
import PasswordWarningModal from './Components/Common/PasswordExpiryModal';

//imoprt Route
import Route from './Routes';

function App() {
  return (
    <React.Fragment>
      <Route />
      <PasswordWarningModal />
    </React.Fragment>
  );
}

export default App;
